import { render, staticRenderFns } from "./COA.vue?vue&type=template&id=ea9fd5a0&scoped=true&"
import script from "./COA.vue?vue&type=script&lang=js&"
export * from "./COA.vue?vue&type=script&lang=js&"
import style0 from "./COA.vue?vue&type=style&index=0&id=ea9fd5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9fd5a0",
  null
  
)

export default component.exports